import React from 'react'
import { toast } from 'react-toastify'
import { Box, Button, CircularProgress } from '@material-ui/core'
import { useApi } from '~/store/store'
import { ArrowRightIcon } from '~/assets/icons'
import { useAuthAccount } from '~/store/auth/useAuthAccount'
import { OnboardingRegisterDataActions, trackEvent } from '~/service/analytics'

export const Footer: React.FC = () => {
  const { _id: accountId } = useAuthAccount()
  const [createSerasaScoreAccountDocuments, createSerasaScoreAccountDocumentsState] = useApi('createSerasaScoreAccountDocuments')
  const { loading } = createSerasaScoreAccountDocumentsState

  const onContinueClick = async () => {
    const result = await createSerasaScoreAccountDocuments({
      accountId
    })

    if (result.ok) {
      trackEvent(OnboardingRegisterDataActions.GO_TO_PENDENCIES_PAGE)
      window.location.reload()
      return
    }

    toast.error('Erro ao continuar com a proposta. Tente novamente em alguns instantes.', {
      autoClose: 3000,
      closeButton: false,
      position: toast.POSITION.TOP_RIGHT
    })
  }

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'flex-end'
    }}>
      <Button
        type='submit'
        size='large'
        color='primary'
        onClick={onContinueClick}
        disabled={loading}
        variant='contained'
        sx={{
          height: 56,
          marginTop: 2,
          fontWeight: 700,
          textTransform: 'none'
        }}
        endIcon={loading ? <CircularProgress color='inherit' size={20} /> : <ArrowRightIcon width={24} height={24} />}
      >
        Continuar análise
      </Button>
    </Box>
  )
}
